export default __webpack_public_path__ + "static/bg-contact-6e0392f9d1de95612277b48693fee6cd.svg";